import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faBan } from '@fortawesome/pro-solid-svg-icons'

import { Text } from '@domain-group/suit-theme'

interface ZuoraSubscriptionStatusProps {
  isSynced: boolean,
}

const ZuoraSubscriptionStatus = (props: ZuoraSubscriptionStatusProps) => {
  const { isSynced } = props

  const color = isSynced ? 'green' : 'red'
  const description = isSynced ? 'Zuora Subscription Synced' : 'Zuora Not Synced'
  const icon = isSynced ? faCheckCircle : faBan

  return (
    <>
      <Text color={color} fontSize="small">
        <FontAwesomeIcon icon={icon} />
      </Text>

      <Text
        color="bodyFontLightColor"
        fontSize="small"
        marginLeft="large"
        maxWidth="60%"
        variant="ellipsis"
      >
        {description}
      </Text>
    </>

  )
}

export default ZuoraSubscriptionStatus
